import * as Output from '../../Text';

export const name = v => (!v || /^[a-zA-Zß \-.'ÄÅáâäàãåÉéêëèíîïìÖóôöòõÜúüûùÇçÑñŠš()]*$/.test(v)
  ? undefined
  : Output.resolve(
    'generic.errors.M002_invalidCharacters',
  ));
